module.exports = __webpack_public_path__ + "img/car_00068.ae8f7f79.jpg";